import React from "react";
import { useDropzone, DropzoneOptions, DropEvent } from "react-dropzone";

// Icons
import WarningIcon from "../../images/Icon_Warning.png";

type DropzoneProps = {
  children?(isDragActive: boolean): React.ReactNode;
  uploadedFile?: any;
  onDrop<T extends File>(
    acceptedFiles: T[],
    rejectedFiles: T[],
    event: DropEvent
  ): void;
  resetFile: () => void;
  fileType?: string;
  dropzoneOptions?: DropzoneOptions;
  readOnly: boolean;
  dropzoneText?: string;
  uploadIcon?: string;
  warningIcon?: string;
  showWarningMessage?: string | null;
  hasUploadedImage?: boolean;
  uploadedImageUrl?: string;
  fileName?: string;
  isCSVCheck: (file: File) => boolean;
};

function DropzoneCSVOnly<T>(props: DropzoneProps) {
  const [imageBase64, setImageBase64] = React.useState<string>("");

  if (props.uploadedFile && props.uploadedFile.type && props.isCSVCheck(props.uploadedFile[0])) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const imageBase64 = reader.result;
      setImageBase64(imageBase64 as string);
    };
    reader.readAsDataURL(props.uploadedFile);
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    ...props.dropzoneOptions,
    onDrop: props.onDrop,
    disabled: props.readOnly,
  });

  return (
    <div
      className={
        props.uploadedFile || props.hasUploadedImage
          ? "Dropzone Disabled"
          : "Dropzone"
      }
      {...getRootProps()}
    >
      {/* If no files uploaded */}
      {!props.uploadedFile && (
        <>
          <input
            {...getInputProps({
              multiple: false,
            })}
          />

          {props.children ? (
            props.children(isDragActive)
          ) : props.hasUploadedImage ? (
            <>
              <img src={props.uploadedImageUrl} alt="Upload" />
            </>
          ) : (
            <>
              {!props.showWarningMessage ? (
                <>
                  {props.dropzoneText && <p>{props.dropzoneText}</p>}
                </>
              ) : (
                <span className="WarningMessage NoImage">
                  {props.warningIcon ? (
                    <img
                      className="Icon"
                      src={props.warningIcon}
                      alt="Upload"
                    />
                  ) : (
                    <img className="Icon" src={WarningIcon} alt="Upload" />
                  )}

                  {props.showWarningMessage}
                </span>
              )}
            </>
          )}
        </>
      )}

      {/* If file uploaded, display it */}
      {props.uploadedFile && (
        <>
          {props.fileName !== "" && props.fileName !== undefined ? (
            <p>{props.fileName}</p>
          ) : (
            <p>{props.uploadedFile.name || props.fileName}</p>
          )}
        </>
      )}
    </div>
  );
}

export { DropzoneCSVOnly };
